import { render, staticRenderFns } from "./PopoverList.vue?vue&type=template&id=02b6a8b2&"
import script from "./PopoverList.vue?vue&type=script&lang=ts&"
export * from "./PopoverList.vue?vue&type=script&lang=ts&"
import style0 from "./PopoverList.vue?vue&type=style&index=0&id=02b6a8b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports